import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/authentication-hub');
  };

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-primary to-blue-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/20 rounded-full mb-6">
          <Icon name="Sparkles" size={16} color="#FFFFFF" />
          <span className="text-sm font-medium text-white">
            Comece Gratuitamente
          </span>
        </div>

        <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
          Pronto para transformar sua prática?
        </h2>

        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Junte-se a milhares de psicólogos que já simplificaram sua rotina com o {import.meta.env.VITE_APP_TITLE}. Teste grátis por 14 dias sem cartão de crédito.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Button
            variant="default"
            size="lg"
            onClick={handleGetStarted}
            iconName="ArrowRight"
            iconPosition="right"
            className="bg-white text-primary hover:bg-white/90 shadow-xl"
          >
            Começar Agora - É Grátis
          </Button>
          <Button
            variant="outline"
            size="lg"
            iconName="Play"
            iconPosition="left"
            className="border-white text-white hover:bg-white/10"
          >
            Assistir Demonstração
          </Button>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/90">
          <div className="flex items-center gap-2">
            <Icon name="Check" size={20} color="#FFFFFF" />
            <span>14 dias grátis sem cartão de crédito</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Check" size={20} color="#FFFFFF" />
            <span>Cancele quando quiser</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;